import type React from 'react';
import { useEffect, useState } from 'react';

import { ButtonGroup, FormField, Label, ToggleButton } from '@zillow/constellation-10';

import PropertyType_v1 from './PropertyType_v1';
import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: Section) => void;
};

function PropertyType_v2({ section, setSectionValues, setSection }: Props): JSX.Element {
  useEffect(() => {
    section.showMandate = false;
    setSection(section);
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  const [fourUnitsOrFewerClicked, setFourUnitsOrFewerClicked] = useState(false);
  const [fiveUnitsOrMoreClicked, setFiveUnitsOrMoreClicked] = useState(false);

  function onFourUnitsOrFewer(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setFourUnitsOrFewerClicked(true);
    setFiveUnitsOrMoreClicked(false);

    section.showMandate = true;
    setSection(section);
  }

  function onFiveUnitsOrMore(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setFourUnitsOrFewerClicked(false);
    setFiveUnitsOrMoreClicked(true);

    section.showMandate = false;
    setSection(section);
  }

  const isMultiFamily = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY);

  return (
    <PropertyType_v1 {...{ section, setSectionValues, setSection }}>
      {isMultiFamily && (
        <FormField
          required
          label={<Label>How many units are in the property?</Label>}
          control={
            <ButtonGroup orientation="vertical" conjoined aria-label="number of units">
              <ToggleButton
                data-test="property-type-v2-4-units-or-fewer-btn"
                selected={fourUnitsOrFewerClicked}
                onClick={onFourUnitsOrFewer}
              >
                4 units or fewer
              </ToggleButton>
              <ToggleButton
                data-test="property-type-v2-5-units-or-more-btn"
                selected={fiveUnitsOrMoreClicked}
                onClick={onFiveUnitsOrMore}
              >
                5 units or more
              </ToggleButton>
            </ButtonGroup>
          }
        />
      )}
    </PropertyType_v1>
  );
}

export default PropertyType_v2;
